
import { communicationMapState } from "@/store/modules/communication";
import { format } from "date-fns";
import Vue from "vue";
export default Vue.extend({
  name: "dispatched-single-recipient-email-communication",
  components: {
    SingleRecipientSendgridActivities: () =>
      import("./SingleRecipientSendgridActivities.vue"),
    DisplayAttachment: () =>
      import("@/components/DataView/DisplayAttachment.vue")
  },
  methods: {
    formatDate(str: string) {
      const potentialDate = new Date(str);
      if (potentialDate instanceof Date)
        return format(potentialDate, "M/d/yyyy h:mm:ss a");
      else return "N/A";
    }
  },
  computed: {
    ...communicationMapState(["editing"]),
    communication(): any {
      return this.editing;
    },
    communicationRecipient(): string {
      return this.communication && this.communication.communication_message
        ? this.communication.communication_message.data.email
        : "N/A";
    },
    formattedDeliveryMethods(): string {
      if (this.communication) {
        return this.communication.alternateDeliveryMethods
          .map((method: string) => method.toUpperCase())
          .join(" - ");
      } else {
        return "N/A";
      }
    },
    formattedPriority(): string {
      if (this.communication) return this.communication.priority.toUpperCase();
      else return "N/A";
    }
  }
});
